class LayerConfig implements google.maps.ImageMapTypeOptions {
  constructor (public name: string, public tileSize: google.maps.Size, private url: string) {
  }

  getTileUrl (coords: google.maps.Point, zoom: number) {
    const { x, y } = coords

    if (x < 1 || y < 1) { // WTF why this checking is here
      return ''
    }

    return `${this.url}/${zoom}/${x}/${y}.png`
  }
}

export class TiledLayerMapType {
  private readonly origin = 'https://s3-eu-central-1.amazonaws.com'
  private readonly bucketName = 'alao-map'
  private readonly rootFolder = 'tiles'
  private readonly instance!: google.maps.ImageMapType

  constructor (
    private readonly network: string,
    private readonly version: string,
    layer: string,
    path: string,
    tileSize: google.maps.Size,
  ) {
    const baseUrlWithPath = `${this.baseURL}/${path}`
    const layerConfig = new LayerConfig(layer, tileSize, baseUrlWithPath)
    this.instance = new google.maps.ImageMapType(layerConfig)
  }

  get baseURL () {
    return `${this.origin}/${this.bucketName}/${this.rootFolder}/${this.network}/${this.version}`
  }

  getInstance () {
    return this.instance
  }
}
